import { createSlice } from "@reduxjs/toolkit";

const initialRequestLogReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  paymentMethodStatusList: [],
  exportData: [],
  reportType: [],
  eventList: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const RequestLogReportSlice = createSlice({
  name: "requestLogReport",
  initialState: initialRequestLogReportState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
      state.reportType = [];
      // state.eventList = [];
    },
    totalEmptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
      state.exportData = [];
      state.reportType = [];
      state.eventList = [];
    },
    businessDailyReportList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    businessDailyReportExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    reportApiType: (state, action) => {
      const { exportData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
      state.exportData = [];
      state.reportType = exportData;
    },
    dateRangeReportList: (state, action) => {
      const { exportData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.eventList = exportData;
    },
  },
});
